import { createEntityAdapter, createSlice, EntityState, PayloadAction } from "@reduxjs/toolkit";
import { DynamicDataObk, Graph_QL } from "../../..";
import { Widget } from "../GQLCalls/wigdetCalls";
import { isEqual, keyBy, merge } from "lodash";

export type WidgetItem = DynamicDataObk<Widget[]>

const widgetDataAdapter = createEntityAdapter({
  selectId: (item: WidgetItem) => Graph_QL.ObjToString(item.con)
});

const updatePayloadAndState = (state: EntityState<WidgetItem, string>, { con, data }: WidgetItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "widget_id");
    data.forEach((entry) => dataDictionary[entry.widget_id] = entry);
    const newPayload = { con, data: Object.values(dataDictionary) };
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      widgetDataAdapter.upsertOne(state, newPayload);
    }
  } else { widgetDataAdapter.addOne(state, { con, data }) }
}

const mergePayloadAndState = (state: EntityState<WidgetItem, string>, {con, data}: WidgetItem) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const existingData = state.entities[identifier].data;
    const dataDictionary = keyBy(state.entities[identifier].data, "widget_id")
    data.forEach((entry) => dataDictionary[entry.widget_id] = merge({}, dataDictionary[entry.widget_id], entry));
    const newPayload = {con, data: Object.values(dataDictionary)}
    if (newPayload.data.length !== existingData.length || !isEqual(existingData, newPayload.data) ) {
      widgetDataAdapter.upsertOne(state, newPayload);
    }
  } else { widgetDataAdapter.addOne(state, {con, data})}
}

const removeDeletedFromState = (state: EntityState<WidgetItem, string>, {con, data}: DynamicDataObk<number[]>) => {
  const identifier = Graph_QL.ObjToString(con);
  if (state.entities[identifier]) {
    const newPayload = {con, data: state.entities[identifier].data.filter((widget) => !data.includes(widget.widget_id))}
    widgetDataAdapter.upsertOne(state, newPayload);
  }
}

const widgetSlice = createSlice({
  name: "widget",
  initialState: widgetDataAdapter.getInitialState<WidgetItem[]>([]),
  reducers: {
    update: (state, { payload }: PayloadAction<WidgetItem>) => {
      updatePayloadAndState(state, payload);
    },
    maintained: (state, { payload }: PayloadAction<WidgetItem>) => {
      mergePayloadAndState(state, payload);
    },
    deleted: (state, { payload }) => {
      removeDeletedFromState(state, payload)
    }
  }
})

export const widgetActions = widgetSlice.actions;
export default widgetSlice.reducer;